export const shouldRedirectFromCarePlanTab = ({
  arePostHogFlagsLoaded,
  isCarePlanFeatureEnabled,
  isCarePlanTab,
}: {
  arePostHogFlagsLoaded: boolean;
  isCarePlanFeatureEnabled: boolean;
  isCarePlanTab: boolean;
}): boolean =>
  arePostHogFlagsLoaded && !isCarePlanFeatureEnabled && isCarePlanTab;

export const shouldShowPreVisitRecap = ({
  appointmentStatus,
  isCarePlanFeatureEnabled,
}: {
  appointmentStatus: string | null;
  isCarePlanFeatureEnabled: boolean;
}): boolean =>
  isCarePlanFeatureEnabled &&
  (appointmentStatus === 'NOT_STARTED' || appointmentStatus === 'ACTIVE');
